import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ControlTwoToneSvg from "@ant-design/icons-svg/es/asn/ControlTwoTone";
import AntdIcon from "../components/AntdIcon";
var ControlTwoTone = function ControlTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ControlTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ControlTwoTone.displayName = 'ControlTwoTone';
}
export default /*#__PURE__*/React.forwardRef(ControlTwoTone);